import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IconService } from '@isophi/core-ui';
import { Product } from '@isophi/teachers-shared';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-promo-product',
    templateUrl: './promo-product.component.html',
    styleUrls: ['./promo-product.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PromoProductComponent implements OnChanges {
  @Input() hasLicense: boolean;

  @Input() products: Product[];

  customOptions: OwlOptions = {
    autoWidth: true,
    loop: false,
    margin: 25,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    autoplay: true,
    nav: true,
    navText: ['<img src="assets/img/prev.svg" />', '<img src="assets/img/next.svg" />'],
    responsive: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      0: {
        items: 1,
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      780: {
        items: 2,
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      1000: {
        items: 3,
      },
    },
  };

  constructor(public icons: IconService) {}

  ngOnChanges(): void {
    this.customOptions = { ...this.customOptions, loop: this.products?.length > 2 ? true : false };
  }
}
